import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const StyledRootLayout = styled('div')`
  width: calc(100vw - 16px);
  height: 100%;
  min-height: 100vh;
  color: ${colors.bodyText};
  background: #fcfeff;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  overflow: hidden;
`
